export default "__VITE_ASSET__b$9ImSdK__"